<template>
   <div>
  <component v-for="(field, index) in data"
               :key="index"
               :is="field.fieldType"
               v-bind="field">
                 </component>
   </div>
</template>

<script>
import dynamicList from '../dynamicPage/List'
import dynamicBlockquote from '../dynamicPage/BlockQuote'
export default {
        props : {
            data : Array
        },
        components : {
            dynamicList,dynamicBlockquote
        }
}
</script>

<style>

</style>
